































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import OcgMaterialCard from './components/MaterialCard.vue';
import AppService from '@/services/app';

// services 
import CampaignService from '@/services/campaign';

// models
import { Campaign } from '@/models/Campaign.model';

// 3rd party
import downloadExcel from 'vue-json-excel/JsonExcel.vue';

@Component({
  components: {
    OcgMaterialCard,
    downloadExcel,
  },
})
export default class CMSDataTable extends Vue {

  // used by Filter Area
  search: string = '';

  // used by No Data Slot
  isLoading: boolean = true;

  // used by
  showItemDialog: boolean = false;
  title: string = '';
  clickedItem: Campaign = {
    id: 0,
    campaignName: '',
    code: 0,
    partner: '',
    survey: '',
    allocated: 0,
    used: 0,
  };

  valid: boolean = false;
  rules = {
      required: (value: string) => !!value || '',
  };
  
  // #region Functions to display list data on page load
    headers() {
      return [
        {
          text: 'Campaign Name',
          value: 'campaignName',
        },
        {
          text: 'Code',
          value: 'code',
        },
        {
          text: 'Partner',
          value: 'partner',
        },
        {
          text: 'Survey',
          value: 'survey',
        },
        {
          text: 'Allocated',
          value: 'allocated',
        },
        {
          text: 'Used',
          value: 'used',
        },
        {
          sortable: false,
          text: '',
          value: 'action',
          align: 'end',
        },
      ];
    }

    async beforeMount() {
      await this.listAll();
    }

    async listAll() {
      try {
        this.isLoading = true;
        const response: string = await CampaignService.listAll(true);
        
        if (response.length > 0) {
          AppService.errorHandler(response);
        }      

      } finally {
        this.isLoading = false;
      }
    }
    
    viewUsers(item: Campaign) {
      this.$router.push({ name: 'Users', params: { campaignCode: '' + item.code } } );
    }
  // #endregion
}
